import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'react/api/actions';
import { bindActionCreators } from 'redux';
import ReCAPTCHA from 'react-google-recaptcha';
import parse from 'html-react-parser';

import ChangePasswordModal from 'react/containers/modals/ChangePasswordModal';
import LoadingLogin from 'react/components/LoadingLogin';

import { DefaultRequest } from 'scripts/api';
import { getResourceTo } from 'react/utils/utils';

class Login extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
      inputTypePassword: 'password',
      mdlpStatus: true
    };
  }

  handleMdlp() {
    new DefaultRequest({
      url: 'Mdlp/IsEnabled',
      method: 'GET',
      reloadWhenReceiveForbidden: false,
      success: (data) => {
        const { status } = JSON.parse(data);
        const encodedUrl = `Mdlp/Redirect?targetUrl=${encodeURIComponent('#/')}`;

        this.setState({ mdlpStatus: status });

        if (status) {
          window.location.href = encodedUrl;
        }
      },
      error: () => {
        this.setState({ mdlpStatus: false });
      }
    }).send();
  }

  componentDidMount() {
    document.title = 'GreenMile Live';
    window.globalStore.dispatch(actions.auth.actionCreators.getIdentityProvidersListRequest());
    const { i18nActions } = this.props;
    i18nActions.setLocale({ language: navigator.language.substring(0, 2) });
    i18nActions.fetchResourcesByKey([
      'login.forgotpassword',
      'Login.CheckRecaptcha',
      'user.notfound',
      'ForgotPassword.email.success',
      'user.enter.username',
      'user.locked',
      'IpRange.Forbidden',
      'user.accountExpired',
      'PasswordPolicy.error.policyViolation',
      'user.enter.password',
      'user.enter.login.inputs',
      'loading.message',
      'button.login',
      'login.label.logoffNotice',
      'login.label.description',
      'Password.CannotBeChangedException',
      'auth.genericError'
    ]);

    this.handleMdlp();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { auth, i18n, modalActions } = nextProps;
    const showModal = auth.get('showModal');
    const showToast = auth.get('showToast');
    const loginErrors = auth.get('errors');

    if (showModal) {
      modalActions.changeIsOpen(true);
    } else if (loginErrors.size > 0 && showToast) {
      const { errorMessageServerDown } = this.props;
      $.toast({
        message: i18n.get(loginErrors.get('resourceKey')) || errorMessageServerDown,
        displayTime: 5000,
        inTime: 100,
        outTime: 400,
        vPosition: 'center',
        hPosition: 'center',
        className: 'toastError login',
        maxWidth: 700
      });
    }

    nextProps.authActions.setAttr({ id: 'showModal', value: false });
    nextProps.authActions.setAttr({ id: 'showToast', value: false });
  }

  onChange = ({ target: { value, id } }) => {
    const { authActions } = this.props;
    authActions.onChange({ value, id });
  };

  onKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.submit();
    }
  };

  onReCAPTCHAChange = (response) => {
    const { authActions } = this.props;
    authActions.setRecaptchaResponse(response);
  };

  showReCAPTCHA = () => (
    <ReCAPTCHA
      ref={(e) => (this.grecaptcha = e)}
      className="captcha"
      sitekey="6Ld5NS0UAAAAABvTeB7cEQfHnsa3Z2U9102D8cIW"
      onChange={this.onReCAPTCHAChange}
      theme="light"
    />
  );

  resetReCAPTCHA = () => {
    const { authActions } = this.props;
    this.grecaptcha.reset();
    authActions.setRecaptchaResponse('');
  };

  forgotPassword = () => {
    const { i18n } = this.props;
    const text = i18n.get('login.forgotpassword', '');
    return (
      <a className="forgotPassword" onClick={this.sendForgotPass}>
        {text}
      </a>
    );
  };

  showSuccess = () => {
    const { i18n } = this.props;
    const text = i18n.get('ForgotPassword.email.success');
    this.backToInitialState();
    return (
      <span className="successForgotPass">
        {text}
      </span>
    );
  };

  backToInitialState = () => {
    const { authActions } = this.props;
    setTimeout(() => {
      authActions.forgotPassBacktoInitialState();
    }, 5000);
  };

  sendForgotPass = () => {
    const { auth, authActions } = this.props;
    const username = auth.getIn(['user', 'j_username']);

    if (username) {
      const ajax = new Monet.Ajax();
      const data = {
        login: username
      };
      ajax.url = '/User/ForgotPassword';
      ajax.method = 'post';
      ajax.data = data;
      ajax.success = () => {
        authActions.showSuccessAtForgotPass(username);
        authActions.showErrorsAtForgotPass(username);
      };
      ajax.error = (e) => {
        const responseError = JSON.parse(e.responseText || '{}')?.errorMessages?.[0]?.resource?.key;
        const defaultError = 'auth.genericError';
        const errorResource = getResourceTo(responseError ?? defaultError);

        Monet.Authentication.showError(errorResource);
      };
      ajax.send();
    } else {
      authActions.showErrorsAtForgotPass(username);
    }
  };

  submit = () => {
    const { auth, authActions, i18n } = this.props;
    const showRecaptcha = auth.get('showRecaptcha');
    const recaptchaResponse = auth.getIn(['user', 'g_recaptcha_response']);

    if (showRecaptcha && !recaptchaResponse) {
      const { errorMessageServerDown } = this.props;
      const message = i18n.get('Login.CheckRecaptcha') || errorMessageServerDown;

      $.toast({
        message,
        displayTime: 3000,
        inTime: 100,
        outTime: 400,
        vPosition: 'center',
        hPosition: 'center',
        className: 'toastError login',
        maxWidth: 700
      });
    } else {
      authActions.login();
    }

    if (showRecaptcha && recaptchaResponse) {
      this.resetReCAPTCHA();
    }
  };

  togglePasswordInputType = () => {
    const { inputTypePassword } = this.state;
    this.setState({
      inputTypePassword: inputTypePassword === 'text' ? 'password' : 'text'
    });
  }

  renderLogin = () => {
    const { auth, i18n } = this.props;
    const showRecaptcha = auth.get('showRecaptcha');
    const showSuccessAtForgotPass = auth.get('showSuccessAtForgotPass');
    const showErrorUsername = auth.get('showErrorUsername');
    const showErrorPassword = auth.get('showErrorPassword');
    const showLoginError = auth.get('showLoginError');
    const showTimeoutLogoffNotice = auth.get('showTimeoutLogoffNotice');
    const login = auth.getIn(['user', 'j_username']);
    const password = auth.getIn(['user', 'j_password']);
    const identityProvidersList = auth.get('identityProvidersList');
    const { inputTypePassword } = this.state;
    const icon = (inputTypePassword === 'text') ? 'eye-slashed' : 'eye';
    const loginErrorUsernameMessage = i18n.get('user.enter.username', 'Insert your username');
    const loginErrorPasswordMessage = i18n.get('user.enter.password', 'Insert your password');
    const logoffNoticeMessage = i18n.get('login.label.logoffNotice', 'You got disconnected due to inactivity.');
    const loginErrorMessage = i18n.get('user.enter.inputs', 'Insert your username and password');
    const loginDescription = i18n.get('login.label.description', 'Log in to');
    const loginButtonI18n = i18n.get('button.login', 'Log in with');
    const loginButtonSubmit = i18n.get('login.label.description', 'Log in');
    const usernameErrorClass = (showErrorUsername || showLoginError) ? 'error' : '';
    const passwordErrorClass = (showErrorPassword || showLoginError) ? 'error' : '';

    return (
      <>
        <div className="loginForm">
          <span className="loginDescription">{`${loginDescription} GreenMile Live`}</span>
          <span className="loginVersion" title={App.Version.displayInfo}>
            {App.Version.GMLSemanticVersion}
          </span>
          <div className="loginInput login-username-input">
            <input
              className={`usernameEmpty ${usernameErrorClass}`}
              value={login}
              placeholder="Username"
              id="j_username"
              type="type"
              tabIndex="0"
              onChange={this.onChange}
            />
            {showErrorUsername
              && (
                <span className="errorMessage">
                  {loginErrorUsernameMessage}
                </span>
              )}
          </div>
          <div>
            <div className="loginInput login-password-input">
              <input
                className={passwordErrorClass}
                value={password}
                id="j_password"
                type={inputTypePassword}
                placeholder="Password"
                tabIndex="0"
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
              <i
                className={icon}
                role="button"
                tabIndex="0"
                aria-label="Toggle password"
                onClick={this.togglePasswordInputType}
              />
            </div>
            {showTimeoutLogoffNotice
              && (
                <span className="alertMessage">
                  {logoffNoticeMessage ? parse(logoffNoticeMessage) : ''}
                </span>
              )}
            {showErrorPassword
              && (
                <span className="errorMessage">
                  {loginErrorPasswordMessage}
                </span>
              )}
            {showLoginError
              && (
                <span className="errorMessage">
                  {loginErrorMessage}
                </span>
              )}
          </div>
          {showRecaptcha ? this.showReCAPTCHA() : null}
          {!showSuccessAtForgotPass
            ? this.forgotPassword() : this.showSuccess()}
          <button type="button" onClick={this.submit}>
            {`${loginButtonSubmit}`}
          </button>
        </div>
        {Boolean(identityProvidersList.size) && (
          <>
            <div className="separator">or</div>
            <div className="providerIdentitiesContainer">
              {identityProvidersList.map((identityProvider, index) => {
                const idpLoginURL = identityProvider.get('idpLoginURL')
                const idp = identityProvider.get('idpEntity')
                const idScopes = identityProvider.get('idpScopes')
                const tenant = identityProvider.get('tenant')

                const defaultScope = new URL(idpLoginURL).searchParams.get('scope') || '';

                const [url] = idpLoginURL.split('?');

                const scope = idScopes.get(0) || defaultScope;

                return (
                  <form method="post" enctype="multipart/form-data" action={url} key={`form_${index + 1}`}>
                    <input hidden name="idp" value={idp} />
                    <input hidden name="scope" value={scope} />
                    <input hidden name="tenant" value={tenant} />
                    <button
                      key={`button_${index + 1}`}
                      type="submit"
                      style={{
                        display: 'block',
                        background: `${identityProvider.get('idpThemeColor') || '#8BB03E'} 0% 0% no-repeat padding-box`,
                        color: 'white'
                      }}
                    >
                      {`${loginButtonI18n} ${identityProvider.get('idpName')}`}
                    </button>
                  </form>
                )
              })}
            </div>
          </>
        )}
      </>
    );
  }

  renderLoading = () => {
    const { i18n } = this.props;
    return (
      <div className="loading-container">
        <div data-testid="loading" className="loading" />
        <div className="loading-message">{i18n.get('loading.message', 'Loading...')}</div>
      </div>
    );
  };

  render() {
    const { auth, modal } = this.props;
    const loading = auth.get('loading');
    const loginErrors = auth.get('errors');
    const showRecaptcha = auth.get('showRecaptcha');
    const recaptchaClass = showRecaptcha ? 'recaptcha' : '';
    const login = auth.getIn(['user', 'j_username']);
    const isVisible = modal.get('isOpen');

    if (this.state.mdlpStatus) {
      return <LoadingLogin />;
    }

    return (
      <div id="Login">
        <div id="LoginBox" className={`${recaptchaClass}`}>
          <img className="login-greenmile-logo" alt="brand" src={require('static/images/brand.svg')} width="190" height="48" role="presentation" />
          {loading ? this.renderLoading() : this.renderLogin()}
        </div>
        <ChangePasswordModal isVisible={isVisible} login={login} resourceError={loginErrors.get('resourceKey')} />
      </div>
    );
  }
}

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  modal: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
  i18nActions: PropTypes.object.isRequired,
  modalActions: PropTypes.object.isRequired,
  errorMessageServerDown: PropTypes.string
};

Login.defaultProps = {
  errorMessageServerDown: 'We’re sorry! There was a problem with your login request. Please try again or contact support.'
};

const mapActionsToProps = (dispatch) => ({
  authActions: bindActionCreators(actions.auth.actionCreators, dispatch),
  i18nActions: bindActionCreators(actions.i18n.actionCreators, dispatch),
  modalActions: bindActionCreators(actions.modal.actionCreators, dispatch)
});

export default connect(
  ({ auth, i18n, modal }) => ({ auth, i18n: i18n.get('resources'), modal }),
  mapActionsToProps
)(Login);
